import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

const TabIndicator = (props)=>{
    return jsx("div", {
        className: classNames('tab-indicator-container', props.className),
        children: jsx("div", {
            className: classNames('tab-indicator-bar', {
                'tab-indicator-bar-animate': props.animate
            })
        })
    });
};

export { TabIndicator };
